export default "<div class=\"col-md-12 text-center agreement-box\">\r\n    {{input.agreementText}}\r\n</div>\r\n\r\n"